<template>
  <svg
    class="custom-icon"
    width="40"
    height="50"
    viewBox="0 0 40 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.293 25.3051C15.6835 24.8983 16.3167 24.8983 16.7072 25.3051L24.7072 33.6384C24.9932 33.9363 25.0788 34.3844 24.924 34.7736C24.7692 35.1629 24.4046 35.4166 24.0001 35.4166H19.0001V48.9583C19.0001 49.5336 18.5524 50 18.0001 50H14.0001C13.4478 50 13.0001 49.5336 13.0001 48.9583V35.4166H8.00005C7.59555 35.4166 7.23095 35.1629 7.07615 34.7736C6.92135 34.3844 7.00695 33.9363 7.29295 33.6384L15.293 25.3051Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.05714 0H2C0.895431 0 0 0.895432 0 2V3.87755H2V2L4.05714 2V0ZM0 46.1224V48C0 49.1046 0.895431 50 2 50H4.05714V48H2L2 46.1224H0ZM0 43.3061H2V39.551H0V43.3061ZM0 36.7347H2V32.9796H0V36.7347ZM0 30.1633H2V26.4082H0V30.1633ZM0 23.5918H2V19.8367H0V23.5918ZM0 17.0204H2V13.2653H0V17.0204ZM0 10.449H2V6.69388H0V10.449ZM7.14286 0V2H11.2571V0H7.14286ZM14.3429 0V2H18.4571V0H14.3429ZM21.5429 0V2H25.6571V0H21.5429ZM40 13.2653H38V17.0204H40V13.2653ZM40 19.8367H38V23.5918H40V19.8367ZM40 26.4082H38V30.1633H40V26.4082ZM40 32.9796H38V36.7347H40V32.9796ZM40 39.551H38V43.3061H40V39.551ZM40 46.1224H38V48H35.9429V50H38C39.1046 50 40 49.1046 40 48V46.1224ZM32.8571 50V48H28.7429V50H32.8571ZM25.6571 50V48H23V50H25.6571ZM9.5 50V48H7.14286V50H9.5Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.9998 5.00015L26.9139 2.91421L28.3281 1.5L30.4141 3.58594L28.9998 5.00015ZM32.7498 8.75015L30.2498 6.25015L31.6641 4.83594L34.1641 7.33594L32.7498 8.75015ZM36.0858 12.0861L33.9998 10.0002L35.4141 8.58594L37.5 10.6719L36.0858 12.0861Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.0571 16.0205H25C23.8954 16.0205 23 15.1251 23 14.0205V12.143H25V14.0205L27.0571 14.0205V16.0205ZM23 5.57153H25V9.32663H23V5.57153ZM30.1429 16.0205V14.0205H34.2571V16.0205H30.1429Z"
    />
  </svg>
</template>
